import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_AZURE_SITES,
  GET_AZURE_SITES_SUCCESS,
  GET_AZURE_SITES_ERROR,
} from "./constant";

import { getAzureSitesApi } from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureSitesList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureSitesApi, params, provider);
    yield put({ type: GET_AZURE_SITES_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AZURE_SITES_ERROR, error });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureSiteSaga() {
  yield takeLatest(GET_AZURE_SITES, getAzureSitesList);
}
